import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Designer from "@/pages/Designer";
import Orders from "@/pages/Orders";
import Admin from "@/pages/Admin";
import PaymentResult from "@/pages/PaymentResult";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-atelier">
      <div className="w-10 h-10 border-4 border-primary/30 border-t-primary rounded-full animate-spin" />
    </div>
  );
}

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/tasarim" replace />;
  if (!adminOnly && user.role === "admin") return <Navigate to="/admin" replace />;
  return children;
}

// Tasarım sayfası misafirlere de açık; yalnızca admin kendi paneline yönlendirilir.
// Üyelik, tasarım kaydetme veya ödeme adımında istenir.
function CustomerOrGuest({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (user && user.role === "admin") return <Navigate to="/admin" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/tasarim"
              element={
                <CustomerOrGuest>
                  <Designer />
                </CustomerOrGuest>
              }
            />
            <Route
              path="/siparislerim"
              element={
                <Protected>
                  <Orders />
                </Protected>
              }
            />
            <Route path="/odeme/sonuc" element={<PaymentResult />} />
            <Route
              path="/admin"
              element={
                <Protected adminOnly>
                  <Admin />
                </Protected>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
